import { ChangeDetectionStrategy, Component, ElementRef, input, ViewChild } from '@angular/core';
import '@khmyznikov/pwa-install';
import { ButtonType } from 'lib/ui/buttons';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';

@Component({
	templateUrl: './install-button.component.html',
	selector: 'mod-install-button',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class InstallButtonComponent extends CoreAppComponent {
	@ViewChild('pwaInstall') pwaInstall!: ElementRef;

	public readonly buttonType = input<ButtonType>('primary');
	public readonly isFullSize = input<boolean>(true);

	readonly name = this.originalAppName();
	readonly description = `App for fitness trainers and clients.`;

	readonly eventHandle = (event: any) => {};

	constructor() {
		super();
	}

	show(): void {
		this.pwaInstall.nativeElement.showDialog(true);
	}
}
